module.exports = __webpack_public_path__ + "static/media/public-private-key.1835bd35.svg";